import styled from "styled-components";
import {getColorFromTheme} from "../../../utils/style.utils";

export const NavigationWrapper = styled.nav<{ $isActive?: boolean }>`
    flex: ${props => props.$isActive ? "0 0 80px" : "0 0 251px"};
    padding: ${props => props.$isActive ? "93px 23px 10px 23px" : "30px 21px"};
    z-index: 50;
    transition-duration: .1s;
    display: flex;
    flex-direction: column;
    gap: 71px;
    border-right: 1px solid var(--color-border);
    height: auto;
    align-self: normal;
    background: var(--color-secondary);
    position: sticky;
    flex-shrink: 0;

    .icon {
        svg{
            width: 100%;
        }
    }

    ul {
        display: flex;
        flex-direction: column;
        row-gap: 21px;
        height: 100%;

        li:last-child {
            flex: 1 1 0%;
            display: flex;
            flex-direction: column;
            justify-content: start;
            user-select: none;
            -moz-user-select: none;
            -webkit-user-select: none;
            --ms-user-select: none;
        }

        li a {
            user-select: none;
            padding: ${props => props.$isActive ? "8px" : "8px 35px 8px 8px"};
            justify-content: ${props => props.$isActive ? "center" : "initial"};
            border-radius: 8px;
            display: flex;
            align-items: center;
            column-gap: 0.625rem;
            color: var(--color-text-light);
            font-weight: 600;
            font-size: 15px;
            letter-spacing: 0;
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
            transition: 0.3s ease-in-out;

            span {
                font-size: inherit;
                color: var(--color-text-light);
                display: ${props => props.$isActive ? "none" : "block"};
            }

            svg:not(.first) {
                display: none;
            }

        }

        li a:hover {
            background: var(--color-primary-hover);
        }

        li.active a {
            span {
                color: var(--color-primary);
            }

            svg {
                stroke: none;
                stroke-width: 0;
                flex-shrink: 0;
                filter: none;
                path {
                    fill: rgba(57, 0, 189, 1) !important;
                }
            }

            svg.first {
                display: none;
            }

            svg:not(.first) {
                display: block;
            }

            background: ${getColorFromTheme("secondaryColorLight")};
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        position: fixed;
        bottom: 0px;
        z-index: 10000;
        width: 100%;
        flex-direction: row;
        height: auto;
        background-color: var(--color-secondary-light);
        border-top: 1px solid var(--color-border);
        padding: 16px 25px;
        //min-height: 85px;

        .icon {
            display: none;
        }

        ul {
            flex-direction: row;
            justify-content: space-between;
            width: inherit;
            margin: auto;

            li {
                flex: 0 !important;

                a {
                    width: inherit;
                    flex-direction: column;
                    padding: 0px;

                    span {
                        margin-top: 13px;
                        font-size: 12px;
                        font-weight: 500;
                        font-family: Manrope, sans-serif;
                    }
                }
            }

            li:last-child {
                display: none;
            }

            li.active {
                a {
                    background-color: transparent !important;

                    span {
                        color: #3900BD;
                    }
                }
            }
        }

        ul:last-child {
            display: none;
        }

        ul li a > span {
            display: block !important;
        }

        ul li:hover {
            background: none !important;
        }
    }
`